<div class="share-container">
  <div class="share-header">
    <span class="share-title">Share this conversation</span>
    <img
      class="share-close action-icon"
      alt="Close"
      (click)="closeDialog()"
      (keydown)="closeDialog()"
      src="../../../../assets/icons/svg/x-circle.svg"
      height="32"
      width="32"
    />
  </div>

  <div class="share-input-container">
    <div class="input-container">
      <app-section-autocomplete
        class="input-field auto-complete-style"
        [loggedUserId]="loggedUserId"
        [selectedUsersList]="sharedUsersList"
        (onUserSelectedFromDropdown)="onEvent($event)"
      />
    </div>

    <div
      class="share-button action-button-icon"
      [class.disabled]="isUpdatingUsers"
      (click)="shareUsers()"
      (keydown)="shareUsers()"
    >
      Share
    </div>
  </div>

  <div class="user-listing-container scrollbar-custom-scroll-style">
    <ng-container *ngIf="(sharedUsersList?.length || 0) > 0; else noUsers">
      <table
        mat-table
        [dataSource]="sharedUsersList"
        class="mat-elevation-z1 user-table"
      >
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef class="hidden-header"></th>
          <td mat-cell *matCellDef="let user" class="email-cell">
            {{ user.user_email }}
          </td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef class="hidden-header"></th>
          <td mat-cell *matCellDef="let user" class="role-cell">
            <ng-container
              *ngIf="user.user_id !== loggedUserId; else loggedInUser"
            >
              <span
                class="role opacity-75"
                [matMenuTriggerFor]="accessMenu"
                #accessMenuTrigger="matMenuTrigger"
              >
                {{
                  user.permission === shareAccessLevels.MANAGE_SESSION
                    ? "Owner"
                    : user.permission === shareAccessLevels.READ_ONLY
                    ? "Viewer"
                    : user.permission === shareAccessLevels.CONTRIBUTE
                    ? "Contributor"
                    : "Unknown"
                }}

                <img
                  src="../../../assets/icons/svg/chevron-down.svg"
                  alt="down arrow"
                  class="icon-chevron action-icon"
                  [ngClass]="{
                    'rotate-image-anti': accessMenuTrigger.menuOpen
                  }"
                  height="25"
                  width="25"
                />
              </span>

              <mat-menu
                #accessMenu="matMenu"
                class="access-menu"
                xPosition="before"
              >
                <button
                  mat-menu-item
                  class="mat-button-menu-item"
                  (click)="
                    updateUserPermission(user, shareAccessLevels.MANAGE_SESSION)
                  "
                >
                  <div class="icon-group">
                    <span>Owner</span>
                  </div>
                </button>
                <button
                  mat-menu-item
                  class="mat-button-menu-item"
                  (click)="
                    updateUserPermission(user, shareAccessLevels.READ_ONLY)
                  "
                >
                  <div class="icon-group">
                    <span>Viewer</span>
                  </div>
                </button>
                <button
                  mat-menu-item
                  class="mat-button-menu-item"
                  (click)="
                    updateUserPermission(user, shareAccessLevels.CONTRIBUTE)
                  "
                >
                  <div class="icon-group">
                    <span>Contributor</span>
                  </div>
                </button>
              </mat-menu>
            </ng-container>
            <ng-template #loggedInUser>
              <span class="role opacity-75">
                {{
                  user.permission === shareAccessLevels.MANAGE_SESSION
                    ? "Owner"
                    : user.permission === shareAccessLevels.READ_ONLY
                    ? "Viewer"
                    : user.permission === shareAccessLevels.CONTRIBUTE
                    ? "Contributor"
                    : "Unknown"
                }}
              </span>
            </ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef class="hidden-header"></th>
          <td mat-cell *matCellDef="let user" class="delete-cell">
            <div class="delete-icon">
              <img
                src="../../../../assets/icons/svg/garbage.svg"
                alt="delete"
                height="22"
                width="22"
                class="action-icon"
                [ngClass]="{
                  'd-none': user.user_id == loggedUserId
                }"
                (click)="removeUser(user)"
                (keydown)="removeUser(user)"
              />
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="hidden-header-row"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          class="user-row even-row"
        ></tr>
      </table>
    </ng-container>
    <ng-template #noUsers>
      <div class="no-users">
        <span class="no-users-text">No users added yet</span>
      </div>
    </ng-template>

    <div class="spinner-overlay" *ngIf="isUpdatingUsers">
      <mat-progress-spinner
        class="progress-chat"
        [color]="'primary'"
        [mode]="'indeterminate'"
      >
      </mat-progress-spinner>
    </div>
  </div>
</div>
